import { render, staticRenderFns } from "./Lexicon.vue?vue&type=template&id=528f7446&scoped=true"
import script from "./Lexicon.vue?vue&type=script&lang=js"
export * from "./Lexicon.vue?vue&type=script&lang=js"
import style0 from "./Lexicon.vue?vue&type=style&index=0&id=528f7446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f7446",
  null
  
)

export default component.exports